import { Flex } from '@mantine/core';

import { translate } from '@/shared/i18n/translate';
import { LBButton } from '@/shared/ui-kit/components';

export const ManageWorkRequestView = ({
  accept,
  reject
}: {
  accept: () => void;
  reject: () => void;
}) => (
  <Flex gap={8}>
    <LBButton fullWidth onClick={reject}>
      {translate('commons.reject')}
    </LBButton>
    <LBButton fullWidth onClick={accept}>
      {translate('commons.accept')}
    </LBButton>
  </Flex>
);
